import {Trans} from '@lingui/macro';
import {Button, Divider, Grid, Typography} from '@material-ui/core';
import {createStyles, makeStyles} from '@material-ui/core/styles';
import {i18n2} from 'features/i18n/i18n';
import React, {useState} from 'react';
import {useDispatch} from 'react-redux';
import {Buttons} from '../components/index';
import {
  SelectedProfileSpacGrid,
  SelectProfilesSpacGrid,
} from '../components/ITPS/index';
import {REMOVE_ALL_PROFILE} from '../types';

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      width: '100%',
      height: 'calc(100vh - 150px)',
      padding: theme.spacing(2),
      boxSizing: 'border-box',
    },
    columnLeft: {
      order: 2,
      [theme.breakpoints.up('md')]: {
        order: 1,
      },
    },
    columnCenter: {
      order: 1,
      [theme.breakpoints.up('md')]: {
        order: 2,
      },
      display: 'flex',
    },
    columnRight: {
      order: 3,
    },
    titles: {
      marginBottom: theme.spacing(1),
    },
    gridContainer: {
      width: '100%',
      maxWidth: 700,
    },
    buttonsColumn: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      flexDirection: 'row',
      justifyContent: 'center',
      gap: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        flexDirection: 'column',
        justifyContent: 'center',
        gap: 0,
      },
      height: '100%',
    },
    buttonsSelection: {
      display: 'flex',
      gap: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        flexDirection: 'column',
        width: 220,
        '& > *:not(:last-child)': {
          marginBottom: theme.spacing(2),
        },
        marginBottom: theme.spacing(3),
      },
    },
    buttonsConfirmation: {
      display: 'flex',
      gap: theme.spacing(2),
      [theme.breakpoints.up('md')]: {
        '& > *:not(:last-child)': {
          marginRight: theme.spacing(2),
        },
        marginTop: theme.spacing(3),
      },
    },
    divider: {
      display: 'none',
      [theme.breakpoints.up('md')]: {
        display: 'block',
        width: '80%',
        margin: `${theme.spacing(1)}px 0`,
      },
    },
    btnSelect: {
      width: '100%',
      fontWeight: 600,
      color: '#1C4257',
      borderColor: '#1C4257',
      backgroundColor: 'rgba(21, 101, 192, 0.1)',
      '&:hover': {
        backgroundColor: 'rgba(21, 101, 192, 0.25)',
        borderColor: '#0D47A1',
      },
    },
    btnDeselect: {
      width: '100%',
      fontWeight: 600,
      color: '#8B0000',
      borderColor: '#8B0000',
      backgroundColor: 'rgba(139, 0, 0, 0.1)',
      '&:hover': {
        backgroundColor: 'rgba(139, 0, 0, 0.25)',
        borderColor: '#600000',
      },
    },
  }),
);

const PageProfileSpacGrid = (props) => {
  const classes = useStyles();
  const [selectAll, setSelectAll] = useState(false);
  const dispatch = useDispatch();

  const deselectAll = () => {
    dispatch({type: REMOVE_ALL_PROFILE});
  };

  return (
    <>
      <Grid
        container
        className={classes.root}
        spacing={2}
        direction="row"
        alignItems="stretch">
        <Grid item xs={12} md={5} className={classes.columnLeft}>
          <Typography className={classes.titles} variant="h6">
            <Trans>Seleccionar Perfiles</Trans>
          </Typography>
          <div className={classes.gridContainer}>
            <SelectProfilesSpacGrid id={props.id} />
          </div>
        </Grid>
        <Grid item xs={12} md={2} className={classes.columnCenter}>
          <div className={classes.buttonsColumn}>
            {/* Bloque de selección */}
            <div className={classes.buttonsSelection}>
              <Button
                variant="outlined"
                className={classes.btnSelect}
                onClick={() => setSelectAll(true)}>
                {i18n2._('Seleccionar todos')}
              </Button>

              <Button
                variant="outlined"
                color="primary"
                className={classes.btnDeselect}
                onClick={deselectAll}>
                {i18n2._('Deseleccionar todos')}
              </Button>
            </div>

            {/* Divider visual */}
            <Divider className={classes.divider} />
            {/* Bloque de confirmación */}
            <div className={classes.buttonsConfirmation}>
              <Buttons id={props.id} cancel={props.cancel} useSPAC />
            </div>
          </div>
        </Grid>
        <Grid item xs={12} md={5} className={classes.columnRight}>
          <Typography className={classes.titles} variant="h6">
            <Trans>Perfiles Seleccionados</Trans>
          </Typography>
          <div className={classes.gridContainer}>
            <SelectedProfileSpacGrid
              id={props.id}
              selectAll={selectAll}
              setSelectAll={setSelectAll}
            />
          </div>
        </Grid>
      </Grid>
    </>
  );
};

export default PageProfileSpacGrid;
